import React from 'react';

/**
 * Sub-komponent: Header med expand/collapse-knapp
 */
const RoomsHeader = ({ isExpanded, onToggle, roomCount }) => (
  <button
    onClick={onToggle}
    className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
    aria-expanded={isExpanded}
    aria-label={`Berörda rum - ${roomCount} rum`}
  >
    <div className="flex items-center gap-2">
      <h2 className="text-lg font-semibold text-leadme-gray-dark">Berörda rum</h2>
      <span className="text-sm text-gray-500 font-normal">({roomCount} rum)</span>
    </div>
    <svg
      className={`w-5 h-5 text-gray-500 transform transition-transform ${
        isExpanded ? 'rotate-180' : ''
      }`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>
);

/**
 * Sub-komponent: Innehållet med rummen
 */
const RoomsContent = ({ rooms }) => (
  <div className="px-6 pb-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {rooms.map((room, index) => (
        <div 
          key={room._id || index}
          className="flex items-center gap-3 px-4 py-3 bg-blue-50 border border-blue-200 rounded-lg"
        >
          <div className="w-2 h-2 bg-blue-600 rounded-full flex-shrink-0" aria-hidden="true" />
          <span className="text-sm font-medium text-gray-900">
            {typeof room === 'string' ? room : room.name}
          </span>
        </div>
      ))}
    </div>
  </div>
);

/**
 * RoomsSection - Visar berörda rum i offerten
 * 
 * Renderar en expanderbar sektion med alla rum som ingår i projektet.
 * Använder samma stil som övriga offert-sektioner.
 * 
 * @param {Object} offert - Offert-objektet med puData.rooms
 * @param {boolean} isExpanded - Om sektionen är expanderad
 * @param {function} onToggle - Callback för att växla expand/collapse
 */
const RoomsSection = ({ offert, isExpanded, onToggle }) => {
  const rooms = offert?.puData?.rooms;
  
  // Visa inte sektionen om det inte finns några rum
  if (!rooms || rooms.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      <RoomsHeader 
        isExpanded={isExpanded} 
        onToggle={onToggle} 
        roomCount={rooms.length} 
      />
      {isExpanded && <RoomsContent rooms={rooms} />}
    </div>
  );
};

export default RoomsSection;

